function getDateString(date_string, full, dataFormat) {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const fullMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const d = new Date(date_string);
  const date = d.getDate();
  const day = days[d.getDay()];
  const month = d.getMonth();
  const year = d.getFullYear();

  if (dataFormat) {
    return {
      day,
    };
  }

  return ` ${day}, ${date}${(() => {
    const dateCopy = date.toString();
    const lastNumber = dateCopy[dateCopy.length - 1];

    if (dateCopy[0] === 1 && dateCopy.length === 2) {
      return "th";
    } else if (lastNumber === 1) {
      return "st";
    } else if (lastNumber === 2) {
      return "nd";
    } else if (lastNumber === 3) {
      return "rd";
    }
    return "th";
  })()} of ${!full ? months[month] : fullMonths[month]}${
    full ? `, ${year}` : ""
  }`;
}

export { getDateString };
